import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { useHasGate } from '../../accounts/accountsQueries';
import { ContentAssignButton } from '../../contentAssignments/components/ContentAssignButton';
import { ASSIGN_ANY_CONTENT_GATE } from '../../contentAssignments/contentAssignmentsConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ASSIGN_LABEL_BY_TYPE = {
  TRACK: 'academyCommon.cardMenu.assignCourse',
  LESSON: 'academyCommon.cardMenu.assignLesson',
  SHORT_FORM_CONTENT: 'academyCommon.cardMenu.assignVideo',
  PLAYLIST: 'academyCommon.playlistAssignments.assignPlaylist',
  LEARNING_PATH: 'academyCommon.playlistAssignments.assignPlaylist'
};
const CardMenuAssignContentOption = ({
  contentId,
  contentType,
  contentName = '',
  render
}) => {
  const {
    hasGate
  } = useHasGate(ASSIGN_ANY_CONTENT_GATE);
  if (!hasGate) {
    return null;
  }
  const label = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: ASSIGN_LABEL_BY_TYPE[contentType]
    }), /*#__PURE__*/_jsx(Tag, {
      inline: true,
      margin: "0",
      use: "badge-green",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.cardMenu.new"
      })
    })]
  });
  return /*#__PURE__*/_jsx(ContentAssignButton, {
    contentId: contentId,
    contentName: contentName,
    contentType: contentType,
    render: openModal => {
      if (render) {
        return render(label, openModal);
      }
      return /*#__PURE__*/_jsx(SideNavItem, {
        onClick: openModal,
        role: "navigation-item",
        title: label
      });
    }
  });
};
export default CardMenuAssignContentOption;